import Asset from "./asset";
import ApiHome from "../../utils/api.home";

export default function sketch(p) {
  const FRAMES = 60;
  let sun, bkg;
  let previousX;
  let assets = [];
  let history = {};
  let alfa = 255;
  let timer = 15 * FRAMES;
  let counter = 0;
  let stopped = false;

  p.myCustomRedrawAccordingToNewPropsHandler = function(props) {
    if (props.history) {
      history = props.history;
    }
  };

  let addAsset = function(x, y, img, name, sizeX, sizeY, angl, speed = 0.01) {
    let image = p.loadImage(img, "png");
    assets.push(
      new Asset(p, x, y, image, name, sizeX, sizeY, angl, speed, history)
    );
  };

  p.setup = async function() {
    p.createCanvas(window.innerWidth, window.innerHeight);
    p.frameRate(FRAMES);

    p.background(0);
    sun = p.loadImage("assets/images/sun.jpg");
    bkg = p.loadImage("assets/images/background.jpg");

    await new ApiHome().get().then(response => {
      if (response.data) {
        let assets = response.data;
        assets.forEach(asset => {
          addAsset(
            asset.x,
            asset.y,
            asset.img_url,
            asset.name,
            asset.sizeX,
            asset.sizeY,
            asset.anglee,
            asset.speed
          );
        });
      }
    });
  };

  p.mousePressed = function(event) {
    previousX = event.x;

    assets.forEach(asset => {
      if (asset.isHover()) {
        this.clickedClasset = asset.name;
      }
    });
  };

  p.mouseReleased = function(event) {
    if (event) {
      assets.forEach(asset => {
        if (asset.isHover() && this.clickedClasset === asset.name) {
          asset.clicked();
        }
      });
    }
  };

  p.mouseDragged = function(event) {
    const x = event.x;
    let speed = 0;
    let aditional = 0;

    if (x < previousX) {
      aditional = (previousX - x) / 30;
      speed = 5 + aditional;
    } else if (x > previousX) {
      aditional = (x - previousX) / 30;
      speed = -5 - aditional;
    }

    if (x != previousX) {
      assets.forEach(asset => {
        asset.drag(speed);
      });
    }
  };

  p.draw = function() {
    p.image(bkg, 0, 60, window.innerWidth, window.innerHeight);

    assets.forEach(asset => {
      asset.show();
    });

    let mustStop = false;
    assets.forEach(asset => {
      if (asset.hover(stopped)) {
        mustStop = true;
      }
    });

    if (mustStop) {
      stopped = true;
    } else {
      stopped = false;
    }

    if (counter <= timer) {
      p.textSize(50);
      p.fill(200, 200, 200, alfa);
      p.text("Cryptolands.i", 30, 130);
      p.tint(alfa, alfa, alfa);
      p.image(sun, 320, 97, 40, 40);
      p.noTint();
      p.textSize(16);
      p.text("Buy crypto-assets and become a Cryptolander!", 30, 100 + 20 * 3);
      p.text("Click on the Earth and see for yourself...", 30, 100 + 20 * 4);
      p.textSize(14);
      p.fill(200, 200, 200, 255);
    }

    alfa = alfa - 0.002 * counter;
    counter++;
  };
}



// WEBPACK FOOTER //
// ./src/containers/PlanetsPage/sketch.js